<template>
  <!-- <div class="page-line"> -->
  <div
    class="page-line"
    style="top: 1070px; left: 17px"
    @mouseover="showBasicsInfoEdit = true"
    @mouseleave="showBasicsInfoEdit = false"
  >
    <div
      class="basics_info_edit"
      @click="handleBasicsEdit"
      v-if="showBasicsInfoEdit"
    >
      <i class="el-icon-edit-outline" style="font-size: 18px; color: #fff"></i>
    </div>
    <div
      class="substudentItem"
      v-for="(item, index) in basicsCheckList"
      :key="index"
    >
      <div class="substudentItem-class">
        <img src="@/assets/images/class.png" v-if="item == '班级'" />
        <img src="@/assets/images/name.png" v-if="item == '姓名'" />
        <img src="@/assets/images/school.png" v-if="item == '学校'" />
        <img src="@/assets/images/kaohao.jpg" v-if="item == '考号'" />
        <img src="@/assets/images/kaochang.jpg" v-if="item == '考场'" />
        <img src="@/assets/images/zhuowei.jpg" v-if="item == '座位'" />
        <img src="@/assets/images/zhuanye.jpg" v-if="item == '专业'" />
      </div>
      <div class="substudentItem-area"></div>
    </div>
    <ModalBasicsEdit v-model="modalBasicsEditV" />
  </div>
  <!-- </div> -->
</template>
<script>
/** 封装线 */
import ModalBasicsEdit from "../../views/components/card/modal-basics-info";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    ModalBasicsEdit,
  },
  data() {
    return {
      modalBasicsEditV: false,
      showBasicsInfoEdit: false,
    };
  },
  computed: {
    ...mapState("card", {
      basicsCheckList: (state) => state.basicsCheckList, //选中的信息
    }),
  },
  methods: {
    handleBasicsEdit() {
      this.modalBasicsEditV = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.page-line {
  position: absolute;
  height: 39px;
  text-align: center;
  font-size: 13px;
  transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  -webkit-backface-visibility: hidden;
  -webkit-transform-origin: left center;
  border-bottom: 1px dashed var(--card-color, #000);
  display: flex;
  padding-left: 37%;
  padding-right: 37%;
}

.page-line .substudentItem {
  font-size: 13px;
  flex: 1;
  display: flex;
  flex-direction: row;
  margin-top: 0;
  width: 100px;
  height: 20px;
  .substudentItem-class {
    -webkit-transform: rotate(90deg);
    width: 10px;
    margin-top: 5px;
    margin-left: 35px;
  }
}

.substudentItem-area {
  flex: 1;
  margin-left: 5px;
  padding-top: 25px;
  border-bottom: 1px solid var(--card-color);
}

img {
  width: 12px;
}
.basics_info_edit {
  position: absolute;
  display: flex;
  width: 30px;
  height: 30px;
  top: 7px;
  right: 207px;
  background: #409eff;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 2px 2px 6px #3031339e;
  cursor: pointer;
  z-index: 1;
}
</style>